import { render, staticRenderFns } from "./PadoPlayerInventoryComponent.vue?vue&type=template&id=36dc7b8a&scoped=true"
import script from "./PadoPlayerInventoryComponent.vue?vue&type=script&lang=ts"
export * from "./PadoPlayerInventoryComponent.vue?vue&type=script&lang=ts"
import style0 from "./PadoPlayerInventoryComponent.vue?vue&type=style&index=0&id=36dc7b8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dc7b8a",
  null
  
)

export default component.exports